<script setup lang="ts">
const { headerMenu } = useMenu();
</script>
<template>
  <HeaderLinkBottom :list="headerMenu" />
</template>
